import { Create, SimpleForm } from "react-admin";
import SaveForm from "./SaveForm";
import BackButtonToolbar from "features/BackButtonToolbar";

const CreateExams = () => {
  return (
    <Create
      title="Създаване на изпит"
      actions={<BackButtonToolbar />}
    >
      <SimpleForm>
        <SaveForm />
      </SimpleForm>
    </Create>
  );
};
export default CreateExams;
